import { Globe } from "lucide-react";

/* Flags a company we don't bill domestically, so the team spots them at a
   glance. Hidden entirely for Australian AUD records to keep lists clean. */
export const OverseasBadge = ({ currency, country, testid, className = "" }) => {
  const cur = (currency || "AUD").toUpperCase();
  const land = (country || "").trim();
  const overseas = cur !== "AUD" || (land && land !== "Australia");
  if (!overseas) return null;
  return (
    <span
      title={land ? `${land} · quoted in ${cur}` : `Quoted in ${cur}`}
      data-testid={testid}
      className={`inline-flex items-center gap-1 shrink-0 rounded-full px-1.5 py-[1px] mono text-[10px] font-bold leading-[14px] ${className}`}
      style={{ background: "#E4F0E9", border: "1px solid #A9CFBB", color: "#0E6B3F" }}>
      <Globe className="w-2.5 h-2.5" />
      {cur}
    </span>
  );
};

export default OverseasBadge;
